import {Component, OnInit, ViewChild} from '@angular/core';
import {AppService} from '../app.service';
import {DatePipe} from '@angular/common';
declare let $: any;
declare let window: any;

@Component({
  selector: 'sponsor-console-mobile',
  templateUrl: './sponsorConsoleMobile.component.html',
  styleUrls: ['./sponsorConsoleMobile.component.css', '../app.component.css']
})
export class SponsorConsoleMobileComponent implements OnInit {
  @ViewChild('location') loc;
  cardBackHeight = 0;
  advCards = [];
  useHistory = [];
  transactions = [];
  startDate = "";
  endDate = "";
  viewsForHistory =  0;
  dateCreated = "";
  lastUsedDate = "";

  constructor(private app: AppService, private dp: DatePipe) {

  }

  ngOnInit() {
    this.app.broadcaster.subscribe((value) => {
      this.broadCastHandle(value);
    });
    if (this.app.appMode === 2) {
      this.loadSponsorConsoleCards();
    }
  }

  loadSponsorConsoleCards() {
    console.log("Loading sponsor console");
    this.app.userCards.forEach((c) => {
      if (c.advertisement) {
        this.advCards.push(c);
      }
    });
    console.log("ADV Cards: ", this.advCards);
  }

  cardBackClicked(card) {
    console.log("Card clicked: ", card);
    this.app.selectedSavedCard = card;
    if (this.loc) {
      this.loc.updateWithSelCardInfo();
    }
    this.useHistory = [];
    this.transactions = [];
    this.startDate = "";
    this.endDate = "";
    let dc = new Date(card.date_created);
    let lud = new Date(card.last_used);
    console.log("Date created: ", dc);
    console.log("Last used date: ", lud);
    this.dateCreated = this.dateToString(dc);
    this.lastUsedDate = this.dateToString(lud);
    if ($('#startDate')[0] != null) {
      $('#startDate')[0].value = "";
    }
    if ($('#endDate')[0] != null) {
      $('#endDate')[0].value = "";
    }
    this.getCardUseHistory(card, "", "");
    this.app.getCardTransactionHistory(card.id).subscribe((data: any) => {
      console.log("Card transactions: ", data);
      this.transactions = data;
      this.transactions.forEach((t) => {
        let date = new Date(Date.parse(t.date_time));
        t.date = date;
        t.dateString = this.dateToString(date);
        t.timeString = this.timeToString(date);
      });
    }, (error) => {
      console.log("Transaction error: ", error);
    });
  }

  getCardUseHistory(card, start, end) {
    this.viewsForHistory = 0;
    this.app.getCardUseHistory(card.id, start, end).subscribe((data: any) => {
      console.log("Card use history: ", data);
      this.useHistory = data;
      this.useHistory.forEach((t) => {
        let date = new Date(Date.parse(t.date_and_time));
        t.date = date;
        t.dateString = this.dateToString(date);
        t.timeString = this.timeToString(date);
        t.text = this.getShowLocation(t);
        this.viewsForHistory += t.times_shown;
      });
    }, (error) => {
      console.log("History error: ", error);
    });
  }

  dateToString(date: Date) {
    console.log("Date to string: ", date);
    let month = this.zeroFill(date.getMonth() + 1);
    let day = this.zeroFill(date.getDate());
    let year = this.zeroFill(date.getFullYear());
    console.log("String: ", month + "/" + day + "/" + year);
    return month + "/" + day + "/" + year;
  }

  timeToString(date: Date) {
    let min = this.zeroFill(date.getMinutes());
    let hour = this.zeroFill(date.getHours());
    let sec = this.zeroFill(date.getSeconds());
    return hour + ":" + min + ":" + sec;
  }

  zeroFill(int) {
    return int < 10 ? ("0" + int) : int;
  }

  addMoreImpressions() {
    this.app.appMode = 0;
    setTimeout(() => {
      this.app.broadcast({'event': 'addMoreImpressions'});
    }, 300);
  }

  getEditBoxHeight() {
    let width = window.innerWidth < 1400 ? "100%" : "100%";
    let height = 900;
    return {'height': height + 'px', 'width': width};
  }

  getCardBackDisplayStyle(cardBack) {
    let el = document.getElementById("cardBack" + cardBack.id);
    if (!el) {
      return {};
    }
    let height = el.clientHeight;
    let width = el.clientWidth;

    cardBack.width = width - 40;
    cardBack.height = Math.ceil((width - 40) * 1.4463);
    cardBack.elHeight = height;
    this.cardBackHeight = height;
    let margin = 30;
    if (cardBack.elHeight) {
      margin = Math.ceil((cardBack.elHeight - cardBack.height) / 2);
    }
    return cardBack.id === this.app.selectedSavedCard.id ?
      {'border': '1px solid green', 'box-shadow' : '2px 2px 25px 8px #ffd11a', 'margin' : '20px', 'height': (Math.ceil((width - 40) * 1.6)) + 'px'} :
      {'border': '1px solid black', 'margin' : '20px', 'height': (Math.ceil((width - 40) * 1.6)) + 'px'};
  }

  getDisplayCardStyle() {
    let el = document.getElementById("cardDisplayArea");
    let width = el.offsetWidth;
    let height = 700;
    let potentialWidth = Math.ceil(700 / 1.6);
    let top = 50;
    let left = 0;
    if (width < potentialWidth) {
      width = width - 50;
      height = Math.ceil(width * 1.6);
      top = Math.ceil((800 - height) / 2);
      left = 25;
    } else {
      left = Math.ceil((width - potentialWidth) / 2);
      width = potentialWidth;
    }
    console.log("Width: ", width, " Height: ", height, "Left: ", left);
    return {position: 'absolute', top: top + 'px', left: left + 'px', height: height + 'px', width: width + 'px'};
  }

  getShowLocation(history) {
    switch(history.location_level) {
      case 'NONE':
        return '?';
      case 'STATE':
        return history.location_text;
      case 'ZIP':
        return history.location_text;
      case 'CITY':
        return history.location_text;
      case 'NATIONAL':
        return "National";
      default:
        return '...';
    }
  }

  filterDateChanged() {
    console.log("Start date: ", this.startDate);
    console.log("End date: ", this.endDate);
    if (this.startDate !== "" && this.endDate !== "") {
      let d = new Date(this.startDate + "T08:00:00");
      let d2 = new Date(this.endDate + "T08:00:00");
      console.log("D1: ", d);
      console.log("D2: ", d2);
      this.getCardUseHistory(this.app.selectedSavedCard, this.dateToString(d), this.dateToString(d2));
    } else {
      this.getCardUseHistory(this.app.selectedSavedCard, "", "");
    }
  }

  checkRejection() {
    alert(this.app.selectedSavedCard.reason_for_denial);
  }

  broadCastHandle(value: Object): void {
    switch(value['event']) {
      case 'loadSponsorConsole':
        this.loadSponsorConsoleCards();
        break;
      case 'cardBackClicked':
        this.cardBackClicked(value['card']);
        break;
      case 'selCardChanged':
        this.cardBackClicked(this.app.selectedSavedCard);
        break;
      default:
        break;
    }
  }
}
